import axios from "axios";

let location = window.location.origin;
const API = `${location}/api/GetPhotosByZip`;
let vm = this;

export default {
    get(data) {
        
        return axios.get(API, {
            data: data.mediaFree,
            onDownloadProgress: (evt) => {
                let progress = parseInt((evt.loaded / evt.total) * 100);
                vm.$store.dispatch("setNewDataZip", { idx: data.idx, progress });
            }
        }, this);
    },
};